import {
  parametrosSelect,
  requisitosPropiedades,
  nombresDocumentosAvaluoHipoteca,
  storageKeys,
  validacionPatterns,
  parametrosInmuebles,
} from './constants';
const constants = {
  ...storageKeys,
  ...parametrosSelect,
  ...requisitosPropiedades,
  ...validacionPatterns,
  ...parametrosInmuebles,
  ...nombresDocumentosAvaluoHipoteca,
};

export const environment = {
  production: false,
  // URL_API: `https://arrendamientoscapiro.com/capiro/metodos/`,
  // BASE_API: 'https://arrendamientoscapiro.com/capiro/',
  URL_API: `https://pruebas.arrendamientoscapiro.com/pruebascapiro/metodos/`,
  BASE_API: 'https://pruebas.arrendamientoscapiro.com/pruebascapiro/',

  ...constants,
  rutaImg: 'imagenes/',
  rutaDoc: 'documentos/',
  rutaImgPhp: 'imagenes',
  rutaDocPhp: 'documentos',
};
